import React, { useState, useContext, useEffect, useRef} from 'react';
import { AppBar, Toolbar, Typography, IconButton, MenuList, Drawer, Link, List, ListItem, ListItemText, Box, Avatar, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { ArrowBack, Menu, Add, SupportAgent, Block, Report, Tune, Settings, ReceiptLong, ContactSupport, Logout, AddToHomeScreen, Hub, Assessment, WorkOutline, Insights, ChevronRight, ExpandMore, ExpandLess } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import Profile from './../pages/Profile';
import { WebSocketContext } from "../WebSocketContext";
import { useTheme } from '../contexts/ThemeContext';
import config from '../config';
import { apiAppFetch } from '../utils/apiFetch';
import './../Profile.css';
import './../index.css';
import { getToken, storeToken, removeToken } from '../utils/auth';

function TitleBar() {
  const { userDetails, isRefreshing, trades, netPositions, refreshTradesAndPortfolio } = useContext(WebSocketContext);
  const { isDarkMode, toggleTheme } = useTheme(); // Used useTheme hook
  const location = useLocation();
  const navigate = useNavigate();
  const userId = Number(localStorage.getItem('userId'));
  const user_id = Number(localStorage.getItem('userId'));
  const parent_id = Number(localStorage.getItem('parentId'));
  const user_type = "brokerMLM";
  const clientName = userDetails.clientName;
  const isMLMClient = userDetails?.isMLMClient === "1";
  const intervalRef = useRef(null);

  const whatsappNumber = userDetails.supportContact;
  const whatsappMessage = 'Hello, I need support';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  const referralLink = `https://app.papertrade.co.in/register?ud=${userId}`;
  const message = encodeURIComponent(
    `Hi! Join using my referral link: ${referralLink}`
  );

  const shareOnWhatsApp = () => {
    const whatsappUrl = `https://wa.me/?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  const [marqueeText, setMarqueeText] = useState(null);

  const getTodayScrollText = async () => {
      try 
      {  
        const response = await apiAppFetch('getDefaultScrollText', {
          method: 'POST',
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        setMarqueeText(data.text); 

      } catch (error) {
        // fetch failed silently
      }
  };

  useEffect(() => {
    getTodayScrollText();
    }, []);

  useEffect(() => {
    const ua = window.navigator.userAgent || '';
    const isIPhone = /iPhone/i.test(ua);
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    setShowAddToHomeScreen(isIPhone && !isStandalone);
  }, []);


  const [drawerOpen, setDrawerOpen] = useState(false);
  const [supportDialogOpen, setSupportDialogOpen] = useState(false);
  const [showAddToHomeScreen, setShowAddToHomeScreen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  // Auto-refresh trades every 10 seconds if there are pending orders
  useEffect(() => {
    // Check if there are any pending orders
    const hasPendingOrders = trades.some(trade => trade.orderStatus == "1");

    if (hasPendingOrders) {
      // Clear any existing interval
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      
      // Set up new interval for 10 seconds
      intervalRef.current = setInterval(() => {
        console.log('Auto-refreshing trades due to pending orders...');
        refreshTradesAndPortfolio("both");
      }, 10000); // 10 seconds
      
      console.log('Auto-refresh started for pending orders');
    } else {
      // Clear interval if no pending orders
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        console.log('Auto-refresh stopped - no pending orders');
      }
    }

    // Cleanup on unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [trades]);

  const handleNavigation = (path) => () => {
      setIsMLMMenu(false);
      
      if (path.startsWith('http')) {
        window.open(path, '_blank');
      } else {
        navigate(path);
        location.pathname = path;
      }
      setDrawerOpen(false);
  };

  const doLogin = async (opts = {}) => {
    const { disableAccount = false } = opts;
    if (disableAccount) {
      try {
        const uid = Number(localStorage.getItem('userId'));
        if (uid) {
          await apiAppFetch('enableDisableUser', {
            method: 'POST',
            body: JSON.stringify({ status: 0 }),
          });
        }
      } catch (e) {
        // continue logout even if disable fails
      }
    }
    localStorage.removeItem('authToken');
    removeToken();
    setDrawerOpen(false);
    setSupportDialogOpen(false);
    navigate('/login');
  };

  const handleSupportMenuClick = () => {
    setSupportDialogOpen(true);
  };

  const handleSupportConfirmYes = () => {
    doLogin({ disableAccount: true });
  };

  const handleSupportConfirmNo = () => {
    // window.open(whatsappLink, '_blank');
    setSupportDialogOpen(false);
    setDrawerOpen(false);
  };

  const handleAddToHomeScreen = () => {
    alert('To add this app to your Home Screen:\n1) Tap the Share icon in Safari\n2) Select "Add to Home Screen"\n3) Tap "Add"');
  };

  const showBackButton = location.pathname === '/profile' || location.pathname === '/addScript';
  const isHomePage = location.pathname === '/';
  const [proViewOn, setProViewOn] = useState(() => {
    try {
      const saved = localStorage.getItem('proViewPreference');
      return saved ? JSON.parse(saved) : false;
    } catch (error) {
      return false;
    }
  });

  const handleChangeView = () => {
    const next = !proViewOn;
    setProViewOn(next);
    window.dispatchEvent(new CustomEvent('changeView', { detail: { proView: next } }));
  };

  const [isMLMMenuOpen, setIsMLMMenu] = useState(false);

  const toggleMLMMenu = () => {
    setIsMLMMenu(!isMLMMenuOpen);
  };

  return (
    <>
      <AppBar 
        position="fixed" 
        color="primary" 
        style={{ 
          backgroundColor: 'var(--bg-primary)',
          boxShadow: isDarkMode ? '0px 2px 8px -2px rgba(0,0,0,0.4)' : 'none',
          color: 'var(--text-primary)',
          borderBottom: isDarkMode ? '1px solid var(--border-color)' : '1px solid var(--border-color)'
        }}
      >
        <Toolbar style={{ minHeight:'45px' }}>
          {showBackButton && (
            <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
              <ArrowBack />
            </IconButton>
          )}
          {true && showBackButton==false && (
            <IconButton edge="start" color="inherit" onClick={toggleDrawer(true)}>
              <Menu />
            </IconButton>
          )}
          {!isHomePage && (
            <Typography variant="h6" style={{fontSize:'18px', fontFamily:'Lato', fontWeight:600}}>
              {location.pathname === '/trades' && 'Trades'}
              {location.pathname === '/portfolio' && 'Portfolio'}
              {location.pathname === '/positions' && 'Positions'}
              {location.pathname === '/profile' && 'Profile'}
              {location.pathname === '/performance' && 'Deals'}
              {location.pathname === '/blocked-scripts' && 'Blocked Scripts'}
              {location.pathname === '/change-password' && 'Change Password'}
              {location.pathname === '/addScript' && 'Add Script'}
              {location.pathname === '/rejection-logs' && 'Rejection Logs'}
              {location.pathname === '/quantity-setting' && 'Quantity Setting'}
              {(location.pathname === '/settings' || location.pathname === '/setting') && 'Settings'}
              {location.pathname === '/ledger' && 'Ledger'}
              {location.pathname === '/mlmdashboard' && 'MLM Trades'}
              {location.pathname === '/mlmportfolio' && 'MLM Portfolio'}
              {location.pathname === '/mlmperformance' && 'MLM Performance'}
            </Typography>
          )}
          {isHomePage && (
            <div className="titlebar-home-actions">
              <div className="titlebar-view-toggle">
                <span>Pro View</span>
                <button
                  type="button"
                  className={`titlebar-switch${proViewOn ? ' active' : ''}`}
                  onClick={handleChangeView}
                  aria-pressed={proViewOn}
                  title="Pro View"
                />
              </div>
              <IconButton style={{paddingRight:'0px'}} color="inherit" onClick={() => navigate('/addScript')} title="Add Script">
                <Add />
              </IconButton>
            </div>
          )}
        </Toolbar>
        {/* <marquee style={{
          fontSize:'12px', 
          fontFamily: 'Lato',
          marginTop:'-5px', 
          marginBottom:'5px', 
          fontWeight:'bold',
          color: isDarkMode ? 'var(--text-primary)' : 'inherit' // Theme-aware color
        }}>
          {marqueeText}
        </marquee> */}

        {isRefreshing && <div style={{position: 'absolute', width: '100%', top: '10px'}}>
          <div style={{
            fontSize: '11px', 
            color: isDarkMode ? 'var(--text-primary)' : '#062c2f', 
            background: isDarkMode ? 'var(--bg-secondary)' : 'white', 
            padding: '0px 7px', 
            borderRadius: '11px', 
            margin: '0px auto', 
            width: '81px',
            border: isDarkMode ? '1px solid var(--border-color)' : 'none' // Theme-aware border
          }}>
            Refreshing....
          </div>
        </div>}
      </AppBar>

      

      {/* Compact Redesigned Drawer */}
      <Drawer 
        anchor="left" 
        open={drawerOpen} 
        onClose={toggleDrawer(false)} 
        PaperProps={{
          sx: {
            backgroundColor: 'var(--bg-primary)',
            color: 'var(--text-primary)',
            width: '320px'
          }
        }}
      >
        <div className="drawer-shell">
          <div className="drawer-hero">
            <div className="drawer-profile-row">
              <Avatar
                sx={{
                  width: 52,
                  height: 52,
                  bgcolor: '#D4AF37',
                  color: '#0A0E1A',
                  fontSize: '18px',
                  fontWeight: '700'
                }}
              >
                {userDetails?.clientName && userDetails.clientName.split(" ").map((n) => n[0]).join("").toUpperCase()}
              </Avatar>
              <div className="drawer-profile-copy">
                <div className="drawer-profile-name">{userDetails?.clientName || 'Client'}</div>
                <div className="drawer-profile-id">
                  <span>ID {userDetails?.clientId || '-'}</span>
                  <span className="drawer-status-dot" />
                  <span>Active</span>
                </div>
              </div>
            </div>
          </div>

          <div className="drawer-body">
            <button
              type="button"
              className="drawer-funds-card"
              onClick={() => handleNavigation('/ledger')()}
            >
              <div className="drawer-funds-top">
                <div>
                  <div className="drawer-funds-label">Available Margin</div>
                  <div className="drawer-funds-value">
                    ₹{Number(userDetails?.availableMargin || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                </div>
                <span className="drawer-funds-link">
                  View Ledger
                  <ChevronRight />
                </span>
              </div>
            </button>

            <div className="drawer-section-label">Account</div>
            <div className="drawer-list">
              {[
                { icon: <Block />, label: 'Blocked Scripts', hint: 'Scripts you cannot trade', path: '/blocked-scripts' },
                { icon: <Report />, label: 'Rejection Logs', hint: "Today's rejected orders", path: '/rejection-logs' },
                { icon: <Tune />, label: 'Quantity Setting', hint: 'Per-position and total limits', path: '/quantity-setting' },
                { icon: <ReceiptLong />, label: 'Ledger', hint: 'Account statement', path: '/ledger' },
                { icon: <Settings />, label: 'Settings', hint: 'Theme, sound, password', path: '/settings' }
              ].map((item) => (
                <button
                  key={item.path}
                  type="button"
                  className="drawer-menu-item"
                  onClick={() => handleNavigation(item.path)()}
                >
                  <span className="drawer-menu-icon">{item.icon}</span>
                  <span className="drawer-menu-copy">
                    <span className="drawer-menu-label">{item.label}</span>
                    <span className="drawer-menu-hint">{item.hint}</span>
                  </span>
                  <ChevronRight className="drawer-chevron" />
                </button>
              ))}
            </div>

            {isMLMClient && (
              <>
                <div className="drawer-section-label">MLM</div>
                <div className="drawer-list">
                  <button type="button" className="drawer-menu-item" onClick={toggleMLMMenu}>
                    <span className="drawer-menu-icon"><Hub /></span>
                    <span className="drawer-menu-copy">
                      <span className="drawer-menu-label">MLM Dashboard</span>
                      <span className="drawer-menu-hint">Trades, portfolio, reports</span>
                    </span>
                    {isMLMMenuOpen ? <ExpandLess className="drawer-chevron" /> : <ExpandMore className="drawer-chevron" />}
                  </button>
                  {isMLMMenuOpen && [
                    { icon: <Assessment />, label: 'Trades', path: '/mlmdashboard' },
                    { icon: <WorkOutline />, label: 'Portfolio', path: '/mlmportfolio' },
                    { icon: <Insights />, label: 'Performance', path: '/mlmperformance' },
                    { icon: <ReceiptLong />, label: 'MLM Ledger', path: `https://bluerock.live/broledger_mlm.php?ud=${userId}&r=${user_type}&mid=${parent_id}` },
                    { icon: <Report />, label: 'MLM Summary', path: `https://bluerock.live/summaryReport_mlm.php?ud=${userId}&r=${user_type}&mid=${parent_id}` }
                  ].map((item) => (
                    <button
                      key={item.label}
                      type="button"
                      className="drawer-menu-item nested"
                      onClick={() => handleNavigation(item.path)()}
                    >
                      <span className="drawer-menu-icon">{item.icon}</span>
                      <span className="drawer-menu-label">{item.label}</span>
                      <ChevronRight className="drawer-chevron" />
                    </button>
                  ))}
                </div>
              </>
            )}

            <div className="drawer-section-label">Support</div>
            <div className="drawer-list">
              <button type="button" className="drawer-menu-item" onClick={handleSupportMenuClick}>
                <span className="drawer-menu-icon"><ContactSupport /></span>
                <span className="drawer-menu-copy">
                  <span className="drawer-menu-label">Contact Support</span>
                  <span className="drawer-menu-hint">Get help with your account</span>
                </span>
                <ChevronRight className="drawer-chevron" />
              </button>
              {showAddToHomeScreen && (
                <button type="button" className="drawer-menu-item" onClick={handleAddToHomeScreen}>
                  <span className="drawer-menu-icon"><AddToHomeScreen /></span>
                  <span className="drawer-menu-copy">
                    <span className="drawer-menu-label">Add to Home Screen</span>
                    <span className="drawer-menu-hint">Install the app shortcut</span>
                  </span>
                  <ChevronRight className="drawer-chevron" />
                </button>
              )}
            </div>
          </div>

          <div className="drawer-footer">
            <button type="button" className="drawer-logout-btn" onClick={doLogin}>
              <span className="drawer-menu-icon"><Logout /></span>
              <span className="drawer-menu-label">Logout</span>
            </button>
          </div>
        </div>
      </Drawer>

      <Dialog
        open={supportDialogOpen}
        onClose={() => setSupportDialogOpen(false)}
        aria-labelledby="support-dialog-title"
        aria-describedby="support-dialog-description"
      >
        <DialogTitle id="support-dialog-title">Contact support</DialogTitle>
        <DialogContent>
          <DialogContentText id="support-dialog-description">
            Do you really want to contact support!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={() => setSupportDialogOpen(false)} color="inherit">
            Cancel
          </Button> */}
          <Button onClick={handleSupportConfirmNo} color="primary" variant="outlined">
            No
          </Button>
          <Button onClick={handleSupportConfirmYes} color="error" variant="contained" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default TitleBar;